/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Newsletter_SubmitInputs */

const ja_playdata_home_newsletter_submit = /** @type {(inputs: Playdata_Home_Newsletter_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登録する`)
};

const en_playdata_home_newsletter_submit = /** @type {(inputs: Playdata_Home_Newsletter_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribe`)
};

/**
* | output |
* | --- |
* | "Subscribe" |
*
* @param {Playdata_Home_Newsletter_SubmitInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_newsletter_submit = /** @type {((inputs?: Playdata_Home_Newsletter_SubmitInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Newsletter_SubmitInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_newsletter_submit(inputs)
	return en_playdata_home_newsletter_submit(inputs)
});